<template>
  <div
    class="menu"
    v-if="editorIsActiveOnTable && editable"
  >
    <keyboard-tooltip
      v-for="button in tablesButtons"
      :key="button.value"
      :key-name="button.shortcut"
      :label="button.label"
    >
      <v-btn
        :value="button.value"
        type="button"
        @click="button.action"
        small
        text
        style="min-width: 28px"
        class="px-1 ma-1"
      >
        <v-icon small>
          {{ button.icon }}
        </v-icon>
      </v-btn>
    </keyboard-tooltip>
    <v-divider />
  </div>
</template>

<script>
import { inject, computed } from "vue"
import KeyboardTooltip from "../keyboard_tooltip.vue"
import useTextEditorButtons from "./useTextEditorButtons"

export default {
  name: "TextEditorTableMenu",
  components: {
    KeyboardTooltip,
  },
  props: {
    editable: {
      type: Boolean,
      default: true,
    },
  },

  setup() {
    const editor = inject("editor")

    const { tablesButtons } = useTextEditorButtons(editor, {
      featureTable: true,
    })

    const editorIsActiveOnTable = computed(() => editor.value?.isActive("table") || editor.value?.isActive("tableCell"))

    return {
      tablesButtons,
      editor,
      editorIsActiveOnTable,
    }
  },
}
</script>
